import { Component, Input, OnInit } from '@angular/core';
import { TabsName } from 'src/app/shared/helpers/tabsName';
import { TabsPublicName } from 'src/app/shared/helpers/tabsPublicName';
import { NotificationsService } from '../../api/notifications.service';
import * as _ from 'lodash';
import { PagesPublicName } from 'src/app/shared/helpers/pagesPublicName';
import { LocalService } from 'src/app/api/local-storage.service';

@Component({
  selector: 'app-user-notifications-page',
  templateUrl: './user-notifications-page.component.html',
  styleUrls: ['./user-notifications-page.component.scss', '../../shared/layout/managers.scss'],
})
export class UserNotificationsPageComponent implements OnInit {
  TabsName = TabsName;
  TabsPublicName = TabsPublicName;
  PagesPublicName = PagesPublicName;
  page = 1;
  pageSize = 25;
  multicountryUser = false
  @Input() showRibbon = true;
  constructor(public notificationsService: NotificationsService, private localService: LocalService){
  }
  ngOnInit() {
    this.multicountryUser = _.get(this.localService.getFromLocalStorage('user','file_systems'), 'length', 0) > 1
  }
  trackByFn(index, item) {
    return item.id;
  }
  getUserNotifications = () => {
    return _.get(this, 'notificationsService.userNotifications.value', []);
  };
}
